import { Component, OnInit } from "@angular/core";
import { AdminDashboardService } from "src/app/services/admin-dashboard.service";
import { NotificationService } from "src/app/services/notification.service";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { ThemeService } from "src/app/theme/theme-service.service";
import { ZPNotification } from "../../models/zpnotification";

@Component({
    selector: "app-auditlog",
    templateUrl: "./auditlog.component.html",
    styleUrls: ["./auditlog.component.scss"],
    standalone: false
})
export class AuditLogComponent implements OnInit {
  public list: any;
  public section = "auditlog";
  public item: any;
  public selectedItemCode;
  public disabled: boolean = false;
  public checked: boolean;
  public page: any;
  public totalPages: any;
  public total: any;
  public pageSize = 20;
  public currentPage: number = 1;

  constructor(
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private api: AdminDashboardService,
    private notifications: NotificationService,
    public themeService: ThemeService
  ) {}

  async ngOnInit() {
    this.loadUsers(this.currentPage);
  }

  async loadUsers(page: number) {
    this.api.getList('auditlog', page).then((allUsers) => {
      console.log("allUsers - ", allUsers);
      this.page = allUsers.page;
      this.totalPages = allUsers.pages;
      this.total = allUsers.total;
      this.list = allUsers.items;
    console.log("list: ", this.list);

    });
  }

  toggleSection(code) {
    console.log("list: ", code);
    if (this.selectedItemCode === code) {
      this.selectedItemCode = null;
    } else {
      this.selectedItemCode = code;
    }
  }
}
